<div class="watchlist-add-button-container">
  <!-- Button to Add to Watchlist -->
  <p-button
    appFeatureAccess="standard"
    featureName="watchlists"
    label="Watchlist"
    icon="pi pi-plus"
    (onClick)="openAddDialog()"
    severity="success"
    [outlined]="true"
    styleClass="watchlist-add-button"
  >
  </p-button>
  @if (showCount()) {
    <div
      class="mt-3"
      pTooltip="{{ watchlistNames().join('\n') }}"
      tooltipPosition="bottom"
      [tooltipOptions]="{
        tooltipStyleClass: 'wsy-tooltip-small multiline-tooltip',
      }"
    >
      On
      <span class="bg-yellow-500 text-black rounded p-1">{{
        watchlistCount()
      }}</span>
      @if (watchlistCount() > 1) {
        watchlists
      } @else {
        watchlist
      }
    </div>
  }
</div>

<!-- Add Ticker to Watchlist Dialog -->
<app-watchlist-add-ticker-dialog
  (tickerAdded)="onTickerAdded()"
></app-watchlist-add-ticker-dialog>
